var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCubeMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 68,
    viewBox: "0 0 58 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.9621V50.2127L27.8115 67.9109V34.3962L0 17.9621ZM29.5354 34.3962V68L57.347 52.198V17.9621L29.5354 34.3962ZM56.5146 16.4516L28.6735 32.9031L0.832378 16.4516L28.6735 0L56.5146 16.4516ZM7.85661 16.251L12.8368 19.3366L33.8185 6.26877L28.8382 3.18318L7.85661 16.251ZM20.6711 24.3722L15.6909 21.2866L36.6725 8.21882L41.6527 11.3044L20.6711 24.3722ZM23.8642 26.4748L28.8445 29.5604L49.8261 16.4926L44.8459 13.407L23.8642 26.4748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeMark);
export default __webpack_public_path__ + "static/media/cube-mark.34505285f2ae8cf42b25a487bb2e3425.svg";
export { ForwardRef as ReactComponent };